import React, { useEffect } from 'react';
import axios from '../../../Helpers/Axiosbase'
import { Card, CardHeader, CardContent, Checkbox, TextField, Button, Switch, FormGroup, FormControlLabel,CardActions } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { LinearProgress,Snackbar } from '@material-ui/core';
import { useInputChange } from '../../../Helpers/useInputChange'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import * as actions from '../../../Store/Actions'
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(2),
            width: 250,
        }
    }
}));

export default function AppsManage(props) {
    const [showProgress, setShowProgress] = React.useState(false);
    const [listApps, setListApps] = React.useState([]);
    const [selectedApp, setSelectedApp] = React.useState([]);

    const reduxAuth = useSelector((state) => state.auth)
    const dispatch = useDispatch();

    const { location, history } = useReactRouter();


    const [input, handleInputChange, handleSwitchChange, setInput] = useInputChange({
        appContextCode: "",
        displayName: "",
        isActive: true,
        appids:{value:[]}
    });

    const [errorMessage,setErrorMessage]=React.useState({
        open:false,
        errmsg:null,
      });

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
      };

    const onCancleClickHandler = () =>{
        history.push("/components")
    }

    var onSubmitClickHandler = () => {
        setShowProgress(true);
        input.appids.value = selectedApp.map((currentValue, index) => {
            return currentValue._id;
        })
        // console.log(input);
        let url = input._id ? "componentUpdate" : "componentCreate";
        axios.post(url, { ...input, token: reduxAuth.token, userId: reduxAuth.userId })
            .then(response => {
                history.push('/components');
            })
            .catch(err => {
                if(typeof err.response!="object")
                {
                  setErrorMessage({
                    open:true,
                    // errmsg:err
                  })
                  console.log(err);
                }
                else 
                {
                if (err.response.status === 403) {
                    setShowProgress(false);
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                } else {
                    setShowProgress(false);
                }
            }
            });
    }

    var getApps = () => {
        let url = "getAll"
        let postdata = { objectName: "app", token: reduxAuth.token, userId: reduxAuth.userId }
        axios.post(url, postdata)
            .then(response => {
                setListApps(response.data.response);
                setShowProgress(false);
                if (location.state) {
                    // const selectedEvironmentValues = response.data.response.filter((environment) => {
                    //     return location.state.environments.value.some((selectedEnvironment) => {
                    //         return environment._id === selectedEnvironment;
                    //     });
                    // });
                    // const selectedAppValue = response.data.response.filter((app) => { 
                    //     return location.state.appids.value === app._id })
                    const selectedAppValue = response.data.response.filter((app) => { 
                        return location.state.appids.value.some((selectedApp) => {
                            return app._id === selectedApp;
                        });
                    });
                    // selectedAppValue = selectedAppValue[0];
                    setSelectedApp(selectedAppValue);
                }
            })
            .catch(err => {
                if(typeof err.response!="object")
                {
                  setErrorMessage({
                    open:true,
                    // errmsg:err
                  })
                  console.log(err);
                }
                else 
                {
                if (err.response.status === 403) {
                    setShowProgress(false);
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                } else {
                    setShowProgress(false);
                }
            }
            });
    }

    var autoSelectChangeHandler = (event, value) => {
        if (event.currentTarget.id.includes("select-apps")) {
            setSelectedApp(value);
        }
    }

    useEffect(() => {
        getApps();
        if (location.state) {
            setInput(location.state);
        }
    }, []);

    const classes = useStyles();

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    return (

        <div>
            <Snackbar
                open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="error"
                    color="error"
                    variant="filled">
                    {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
            </Snackbar>
            {showProgress ? <LinearProgress /> : null}
            <Card>
                <CardHeader title="Manage Component" />
                <CardContent >
                    <form className={classes.root}>
                        <div>
                            <TextField name="displayName" id="displayName" label="Display Name" onChange={(event) => handleInputChange(event)} value={input.displayName} />
                            <TextField name="componentContextCode" id="componentContextCode" label="Component Context Code" onChange={(event) => handleInputChange(event)} value={input.componentContextCode} />
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch name="isActive" checked={input.isActive}
                                        onChange={() => handleSwitchChange('isActive')} color="primary" />
                                    }
                                    label="Is Active?" />
                            </FormGroup>
                            <Autocomplete
                                multiple
                                id="select-apps"
                                name="select-apps"
                                options={listApps}
                                onChange={autoSelectChangeHandler}
                                disableCloseOnSelect
                                getOptionLabel={option => option.displayName}
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.displayName}
                                    </React.Fragment>
                                )}
                                style={{ width: 250 }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="App"
                                        placeholder="App"
                                        fullWidth
                                    />
                                )}
                                value={selectedApp}
                            />
                        <CardActions>
                            <Button color="primary" variant="contained" onClick={onSubmitClickHandler}>Submit</Button>
                            <Button color="secondary" variant="contained" onClick={onCancleClickHandler}>Cancle</Button>
                        </CardActions>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}